export interface SettlementCharge {
  id: string
  amountCents: number
}

export interface SettlementPlan {
  feeIds: string[]
  drinkIds: string[]
  remainderCents: number
}

/**
 * US-14's whole-item allocation rules. Inputs must already be oldest-first.
 */
export function planSettlement(
  amountCents: number,
  fees: readonly SettlementCharge[],
  drinks: readonly SettlementCharge[],
): SettlementPlan {
  let remaining = amountCents
  const feeIds: string[] = []
  const drinkIds: string[] = []

  for (const fee of fees) {
    if (fee.amountCents > remaining) break
    feeIds.push(fee.id)
    remaining -= fee.amountCents
  }

  for (const drink of drinks) {
    if (drink.amountCents > remaining) continue
    drinkIds.push(drink.id)
    remaining -= drink.amountCents
  }

  return { feeIds, drinkIds, remainderCents: remaining }
}
